import { type Mouvement, Sens } from '@mairistem/comptabilite';
import type React from 'react';
import PeriodeCouverteComponent from '../../../components/Mouvement/Panel/PeriodeCouverteComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class PeriodeCouvertePanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.PERIODE_COUVERTE;
		this.icon = { name: 'map signs' };
		this.defaultSize = 6;
	}

	getLibelle = (sens: string) =>
		`Période couverte par ${sens === Sens.RECETTE ? 'le produit' : 'la charge'}`;

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find(
			(ligne) => ligne?.dateDebutCharge || ligne?.dateFinCharge,
		);

	isComplete = (data: Mouvement) =>
		this.everyLigneHas(data, 'dateDebutCharge', 'dateFinCharge');

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
		sens: Sens,
	): React.ReactElement {
		return (
			<PeriodeCouverteComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
				sens={sens}
			/>
		);
	};
}

export default PeriodeCouvertePanel;
